import React, { useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';

const GamesTableComponent = ({ games, onGameClick }) => {
  const columns = useMemo(() => [
    {
      field: 'gameName',
      headerName: 'Game Name',
      flex: 2,
      minWidth: 250,
    },
    {
      field: 'moduleId',
      headerName: 'Module ID',
      flex: 1,
      minWidth: 110,
    },
    {
      field: 'clientId',
      headerName: 'Client ID',
      flex: 1,
      minWidth: 130,
    },
    {
      field: 'launchID',
      headerName: 'Launch ID',
      flex: 2,
      minWidth: 250,
    },
    {
      field: 'provider',
      headerName: 'Provider',
      flex: 1,
      minWidth: 130,
    },
    {
      field: 'platform',
      headerName: 'Platform',
      flex: 1,
      minWidth: 130,
    },
    {
      field: 'invalidGame',
      headerName: 'Valid?',
      flex: 0.5,
      minWidth: 90,
      renderCell: (params) => (params.value ? 'No' : 'Yes'),
    },
    {
      field: 'details',
      headerName: 'Details',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%'
        }}>
          <button
            className="data-grid-button"
            onClick={() => onGameClick(params.row)}
          >
            View Details
          </button>
        </div>
      ),
    }
  ], [onGameClick]);

  const rowsWithIds = useMemo(() =>
    games.map((game, index) => ({
      ...game,
      id: game.id || `${game.moduleId}-${game.clientId}-${index}`
    })),
    [games]
  );

  return (
    <div style={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={rowsWithIds}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
        disableColumnMenu
        hideFooterSelectedRowCount
        headerHeight={56}
        rowHeight={52}
      />
    </div>
  );
};

GamesTableComponent.propTypes = {
  games: PropTypes.arrayOf(PropTypes.shape({
    gameName: PropTypes.string,
    moduleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    launchID: PropTypes.string,
    provider: PropTypes.string,
    platform: PropTypes.string,
    invalidGame: PropTypes.bool,
  })).isRequired,
  onGameClick: PropTypes.func.isRequired,
};

export default GamesTableComponent;